import * as PropTypes from 'prop-types';
import React from 'react';

const XSAndSMDiv = props => {
    const classes = props.className ? `visible-sm ${props.className}` : 'visible-sm';
    return <>
        <div
            {...props}
            className={classes}
        >
            {props.children}
        </div>
    </>;
};

XSAndSMDiv.propTypes = {
    className: PropTypes.string,
    id: PropTypes.string,
    style: PropTypes.object,
};
XSAndSMDiv.defaultProps = {
    className: '',
    id: '',
    style: {},
};

export default XSAndSMDiv;